import { find } from '../utils/dom'

export default function textosScripts(){

	const Home = find("[js-page='textos']")
	if (!Home) return
 
 
	

		function toggleTextContent(btn) {
			const langContainer = btn.closest('.portugues, .ingles')
			if (!langContainer) {
				console.warn('langContainer não encontrado para botão:', btn)
				return
			}

			const content = langContainer.querySelector('.faq-content')
			if (!content) {
				console.warn('faq-content não encontrado dentro de:', langContainer)
				return
			}

			const currentMaxHeight = window.getComputedStyle(content).getPropertyValue('max-height')
			if (currentMaxHeight !== '0px') {
				content.style.maxHeight = '0px'
				content.style.opacity = '0'
				const icon = langContainer.querySelector('.faq-icon-open')
				if (icon) icon.style.display = 'inline-block'
			} else {
				content.style.maxHeight = content.scrollHeight + 'px'
				content.style.opacity = '1'
				const icon = langContainer.querySelector('.faq-icon-open')
				if (icon) icon.style.display = 'none'
			}
		}

		function insertBtnInContent(el, btnContent, btnClassList) {
			// Evita inserir botão duplicado
			if (!el)  return;
			if (el.querySelector('button.faq-icon-open')) return;

			const btn = document.createElement('button')
			btn.textContent = btnContent
			btn.style.marginLeft = '.5rem'
			btnClassList.forEach((cls) => btn.classList.add(cls))
			btn.addEventListener('click', function (e) {
				e.stopPropagation(); // Impede propagação para o .faq-card
				toggleTextContent(this)
			})
			el.appendChild(btn)
		}

		function insertButtons() {
			const divTextoAberto = document.querySelectorAll('.texto-aberto')
			divTextoAberto.forEach((texto) => {
				const divLastEl = texto.lastElementChild
				insertBtnInContent(divLastEl, '[+]', ['faq-icon-open'])
			})
			const divTextoFechado = document.querySelectorAll('.texto-fechado')
			divTextoFechado.forEach((texto) => {
				const divLastEl = texto.lastElementChild
				insertBtnInContent(divLastEl, '[-]', ['faq-icon-open'])
			})
		}

		document.addEventListener('DOMContentLoaded', function () {
			insertButtons();

			const faqCards = document.querySelectorAll('.faq-card .portugues, .faq-card .ingles');
			faqCards.forEach(card => {
				card.addEventListener('click', function (e) {
					// Evita disparar se o clique for no botão
					if (e.target.tagName.toLowerCase() === 'button') return;
					const button = card.querySelector('.faq-icon-open');
					toggleTextContent(button);
				});
			});
		}); 
		


}